module.exports = __webpack_public_path__ + "x.svg?b9fbe70935a882d8184f0f49f002a1b9";


//////////////////
// WEBPACK FOOTER
// ./assets/images/x.svg
// module id = 321
// module chunks = 0